import React from 'react';

const ServiceCard = ({ icon, title, description }) => {
  return (
    <div className="glass-card p-6 md:p-8 hover:shadow-soft-lg transition-all duration-300 h-full">
      <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary text-white mb-4">
        {icon}
      </div>
      <h3 className="text-xl font-semibold mb-3">{title}</h3>
      <p className="text-secondary-light">{description}</p>
    </div>
  );
};

const Services = () => {
  return (
    <section id="services" className="section bg-white">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="mb-4 font-bold">
            <span className="text-primary">Fast</span>, Modern, and Done Right
          </h2>
          <p className="text-lg text-secondary-light">
            We build websites that look professional, load quickly, and actually convert visitors into customers.
            No templates, just quality work that delivers results.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <ServiceCard 
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            }
            title="Custom-Built Website"
            description="Tailored specifically to your business, not a generic template. Built to showcase your services and attract your ideal customers."
          />
          
          <ServiceCard 
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            }
            title="Launch-Ready in 7 Days"
            description="No long waits or endless revisions. We work efficiently to deliver your finished website in just one week."
          />
          
          <ServiceCard 
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            }
            title="Complete Lead Generation"
            description="We build websites that actually work for your business - capturing leads and helping you convert them to customers."
          />
          
          <ServiceCard 
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            }
            title="Advanced Services"
            description="Automation, SEO, AI optimization, and other agency-level services to take your online presence to the next level."
          />
        </div>
        
        <div className="mt-16 md:mt-24">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <h2 className="mb-6 font-bold">Why You're <span className="text-primary">Here</span></h2>
              <div className="space-y-4 text-lg">
                <p>
                  We don't send generic pitches. Instead, we found your current website and built you a better version first - then reached out.
                </p>
                <p>
                  If you're here, it means we've already created a working prototype specifically for your business, using your actual services and location. No templates, no guesswork.
                </p>
                <p className="font-medium text-secondary">
                  Want to see what we built for you?
                </p>
                <div className="pt-4">
                  <a href="#contact" className="btn-primary">
                    See My Website Preview
                  </a>
                </div>
              </div>
            </div>
            
            <div className="order-1 md:order-2">
              <div className="relative">
                <div className="absolute -inset-0.5 bg-gradient-to-br from-primary/30 to-accent/30 rounded-3xl blur-lg opacity-30"></div>
                <div className="relative overflow-hidden rounded-2xl shadow-soft">
                  <img 
                    src="https://images.unsplash.com/photo-1519222970733-f546218fa6d7" 
                    alt="Web design process on laptop" 
                    className="w-full h-auto"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
